/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/forbid-prop-types */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Button, { ButtonGroup } from '../Button';
import { EditorButton } from './ToolBarButtons';
import TextField from '../TextField';
import { IconLink, IconLinkOff } from '../icons/Icons';

function stopPropagation(event) {
    event.stopPropagation();
}

export default class LinkComponent extends Component {
    static propTypes = {
        expanded: PropTypes.bool,
        doExpand: PropTypes.func,
        doCollapse: PropTypes.func,
        onExpandEvent: PropTypes.func,
        config: PropTypes.object,
        onChange: PropTypes.func,
        currentState: PropTypes.object,
        translations: PropTypes.object
    };

    state = {
        showModal: false,
        linkTarget: '',
        linkTitle: '',
        linkTargetOption: this.props.config.defaultTargetOption
    };

    componentDidUpdate(prevProps) {
        if (prevProps.expanded && !this.props.expanded) {
            this.setState({
                showModal: false,
                linkTarget: '',
                linkTitle: '',
                linkTargetOption: this.props.config.defaultTargetOption
            });
        }
    }

    removeLink = () => {
        const { onChange } = this.props;
        onChange('unlink');
    };

    addLink = () => {
        const { onChange } = this.props;
        const { linkTitle, linkTarget, linkTargetOption } = this.state;
        onChange('link', linkTitle, linkTarget, linkTargetOption);
    };

    updateValue = (event) => {
        this.setState({
            [`${event.target.name}`]: event.target.value
        });
    };

    updateTargetOption = (event) => {
        this.setState({
            linkTargetOption: event.target.checked ? '_blank' : '_self'
        });
    };

    hideModal = () => {
        this.setState({
            showModal: false
        });
    };

    signalExpandShowModal = () => {
        const {
            onExpandEvent,
            currentState: { link, selectionText }
        } = this.props;
        const { linkTargetOption } = this.state;
        onExpandEvent();
        this.setState({
            showModal: true,
            linkTarget: (link && link.target) || '',
            linkTargetOption: (link && link.targetOption) || linkTargetOption,
            linkTitle: (link && link.title) || selectionText
        });
    };

    forceExpandAndShowModal = () => {
        const {
            doExpand,
            currentState: { link, selectionText }
        } = this.props;
        const { linkTargetOption } = this.state;
        doExpand();
        this.setState({
            showModal: true,
            linkTarget: link && link.target,
            linkTargetOption: (link && link.targetOption) || linkTargetOption,
            linkTitle: (link && link.title) || selectionText
        });
    };

    renderAddLinkModal() {
        const {
            config: { popupClassName },
            doCollapse
        } = this.props;
        const { linkTitle, linkTarget } = this.state;
        return (
            <div
                className={cx('sarsa-rich-text-field-popup', popupClassName)}
                onClick={stopPropagation} >
                <TextField
                    className="mb-2"
                    id="link-text"
                    label="Link Text"
                    name="linkTitle"
                    onChange={this.updateValue}
                    onBlur={this.updateValue}
                    value={linkTitle}
                    shouldFocusOnMount />
                <TextField
                    className="mb-3"
                    id="link-target"
                    label="Link URL"
                    name="linkTarget"
                    onChange={this.updateValue}
                    onBlur={this.updateValue}
                    value={linkTarget} />
                <ButtonGroup isStretchedToFit>
                    <Button
                        appearance="tertiary"
                        onClick={doCollapse}>
                        Cancel
                    </Button>
                    <Button
                        onClick={this.addLink}
                        isDisabled={!linkTarget || !linkTitle} >
                        Add
                    </Button>
                </ButtonGroup>

            </div>
        );
    }

    render() {
        const {
            config: { options, link, unlink, className },
            currentState,
            expanded,
            translations
        } = this.props;
        const { showModal } = this.state;
        const isActive = !!currentState.link?.target;

        return (
            <div
                className={cx('sarsa-rich-text-field-popup-wrapper', className)}>
                {options.indexOf('link') >= 0 && (
                    <EditorButton
                        isActive={isActive}
                        onClick={this.signalExpandShowModal}
                        aria-label="Link"
                        aria-haspopup="true"
                        aria-expanded={showModal}
                        title={link.title || translations['components.controls.link.link']}>
                        <IconLink size="md" />
                    </EditorButton>
                )}
                {options.indexOf('unlink') >= 0 && !!currentState.link && (
                    <EditorButton
                        aria-label="Unlink"
                        disabled={!currentState.link}
                        onClick={this.removeLink}
                        title={
                            unlink.title || translations['components.controls.link.unlink']
                        }>
                        <IconLinkOff size="md" />
                    </EditorButton>
                )}
                {expanded && showModal ? this.renderAddLinkModal() : undefined}
            </div>
        );
    }
}
